import React from 'react';
import './HeroFeatureCards.css';

const featureData = [
  {
    icon: 'las la-user-tie',
    title: 'Expert Counselling',
    desc: 'Guidance tailored to your academic goals and budget.',
  },
  {
    icon: 'las la-university',
    title: 'Top Institutions',
    desc: 'Partnerships with 250+ leading universities worldwide.',
  },
  {
    icon: 'las la-project-diagram',
    title: 'End-to-End Support',
    desc: 'Dedicated support from your first step to graduation.',
  },
  {
    icon: 'las la-award',
    title: 'Scholarships & Aid',
    desc: 'Helping you access top scholarship opportunities.',
  },
  {
    icon: 'las la-passport',
    title: 'Visa Assistance',
    desc: 'Expert guidance for a smooth, successful visa process.',
  },
  {
    icon: 'las la-shield-alt',
    title: 'Post-Arrival Support',
    desc: `We remain reachable long after you've landed abroad.`,
  },
];

const HeroFeatureCards = () => {
  return (
    <div className="hero-feature-wrapper">
      <div className="hero-feature-heading">
        <span className="hero-feature-subtitle">Why Choose Study Concerns?</span>
        <h2>Your Success, Our Commitment</h2>
      </div>
      <div className="hero-feature-container">
        {featureData.map((item, index) => (
          <div className="feature-card" key={index}>
            <span className="icon-circle">
              <i className={item.icon}></i>
            </span>
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeroFeatureCards;
